import React from 'react'

import { CLASS_PREFIX } from 'src/constants'
import './project_steps.scss'

const cls = `${CLASS_PREFIX}project-steps`

type Props = {
  title: string;
  items: ReadonlyArray<string>;
}

export const ProjectSteps: React.FC<Props> = ({ title, items }) => (
  <section className={cls}>
    <h3 className={`${cls}__title`}>{title}</h3>
    <ol className={`${cls}__list`} role="list">
      {items.map((item, index) => (
        <li className={`${cls}__step`} key={item}>
          <span className={`${cls}__number`}>{index + 1}</span>
          <span className={`${cls}__text`}>{item}</span>
        </li>
      ))}
    </ol>
  </section>
)
